import gql from 'graphql-tag';
import client from '../../client';
export const SETUP_STRIPE_PAYMENT_METHOD = gql `
  mutation setupPaymentMethod($input: PaymentInput) {
    setupPaymentMethod(input: $input) @rest(type: "SetupPaymentMethod", path: "payments/setup", method: "POST") {
      data {
        id
        object
        application
        cancellation_reason
        client_secret
        created
        customer
        description
        last_setup_error
        livemode
        mandate
        metadata {
          user_id
        }
        next_action
        on_behalf_of
        payment_method
        payment_method_options {
          card {
            request_three_d_secure
          }
        }
        payment_method_types
        single_use_mandate
        status
        usage
      }
    }
  }
`;
export const setupStripePaymentMethod = (userId) => {
    return client.mutate({
        mutation: SETUP_STRIPE_PAYMENT_METHOD,
        variables: {
            input: {
                userId,
            },
        },
    });
};
export default setupStripePaymentMethod;
